import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize, forkJoin } from 'rxjs';
import { JobTitleService } from 'src/app/api/services';
import { MESSAGES } from 'src/app/core/constant/messages';
import { LoadingComponent } from 'src/app/shared/component/loading/loading.component';
import { ModalFormComponent } from 'src/app/shared/component/modal-form/modal-form.component';
import { TableGenericComponent } from 'src/app/shared/component/table-generic/table-generic.component';
import {
  FormFieldConfig,
  TableAction,
  TableColumn,
} from 'src/app/shared/model/admin';
import { JobTitle } from 'src/app/shared/model/job-title';
import { ToastService } from 'src/app/shared/service/toast.service';
import { handleApiError } from 'src/app/shared/util/handle-api-error';

@Component({
  selector: 'app-job-title',
  imports: [
    CommonModule,
    LoadingComponent,
    TableGenericComponent,
    ModalFormComponent,
  ],
  templateUrl: './job-title.component.html',
  styles: ``,
})
export class JobTitleComponent implements OnInit {
  mostrarModalAgregar: boolean = false;
  mostrarModalEditar: boolean = false;
  loadingAgregar: boolean = false;
  loadingEditar: boolean = false;
  loadingJobTitles: boolean = false;
  editarSeleccionada?: JobTitle;

  jobTitles: JobTitle[] = [];

  formAgregar!: FormGroup;
  formEditar!: FormGroup;

  columns: TableColumn[] = [
    { header: 'Nombre', field: 'name' },
    { header: 'Estado', field: 'state' },
  ];
  actions: TableAction[] = ['edit'];

  fieldsAgregar: FormFieldConfig[] = [
    { name: 'name', label: 'Nombre', placeholder: 'Nombre del cargo' },
  ];
  fieldsEditar: FormFieldConfig[] = [
    { name: 'name', label: 'Nombre', placeholder: 'Nombre del cargo' },
    {
      name: 'state',
      label: 'Estado',
      type: 'select',
      options: [
        { label: 'Activo', value: 'activo' },
        { label: 'Inactivo', value: 'inactivo' },
      ],
    },
  ];

  constructor(
    private fb: FormBuilder,
    private jobTitleService: JobTitleService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.initForms();
    this.cargarJobTitles();
  }

  private initForms(): void {
    this.formAgregar = this.fb.group({ name: ['', Validators.required] });
    this.formEditar = this.fb.group({
      name: ['', Validators.required],
      state: ['', Validators.required],
    });
  }

  private cargarJobTitles(): void {
    this.loadingJobTitles = true;
    this.jobTitleService
      .tituloEmpleoGet()
      .pipe(
        handleApiError(this.toastService, MESSAGES.JOBTITLE.GET_ALL_ERROR),
        finalize(() => (this.loadingJobTitles = false))
      )
      .subscribe((res: any) => {
        this.jobTitles = res.dto?.jobTitles || [];
      });
  }

  openModal(type: 'add' | 'edit', jobTitle?: JobTitle): void {
    this.mostrarModalAgregar = false;
    this.mostrarModalEditar = false;
    this.editarSeleccionada = undefined;

    if (type === 'add') {
      this.formAgregar.reset();
      this.mostrarModalAgregar = true;
      return;
    }

    if (type === 'edit' && jobTitle) {
      this.editarSeleccionada = jobTitle;
      this.formEditar.setValue({
        name: jobTitle.name,
        state: jobTitle.state,
      });
      this.mostrarModalEditar = true;
    }
  }

  crearJobTitle(): void {
    if (this.formAgregar.invalid) {
      this.formAgregar.markAllAsTouched();
      return;
    }

    this.loadingAgregar = true;
    const { name } = this.formAgregar.value;

    this.jobTitleService
      .tituloEmpleoPost({ body: { name } })
      .pipe(
        handleApiError(this.toastService, MESSAGES.JOBTITLE.CREATE_ERROR),
        finalize(() => (this.loadingAgregar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.JOBTITLE.CREATE_SUCCESS,
        ]);
        this.cargarJobTitles();
        this.mostrarModalAgregar = false;
      });
  }

  actualizarJobTitle(): void {
    if (this.formEditar.invalid || !this.editarSeleccionada) {
      this.formEditar.markAllAsTouched();
      return;
    }

    this.loadingEditar = true;
    const { name, state } = this.formEditar.value;
    const idJobTitle = this.editarSeleccionada.idJobTitle;

    const nombre$ = this.jobTitleService.tituloEmpleoIdJobTitlePatch({
      idJobTitle,
      body: { name },
    });

    const estado$ = this.jobTitleService.tituloEmpleoEstadoIdJobTitlePatch({
      idJobTitle,
      body: { state },
    });

    forkJoin([nombre$, estado$])
      .pipe(
        handleApiError(this.toastService, MESSAGES.JOBTITLE.UPDATE_ERROR),
        finalize(() => (this.loadingEditar = false))
      )
      .subscribe(() => {
        this.toastService.showMessages('success', [
          MESSAGES.JOBTITLE.UPDATE_SUCCESS,
        ]);
        this.cargarJobTitles();
        this.mostrarModalEditar = false;
      });
  }
}
